import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import './index.css';
import {addTenantToPayload} from "../../utils";

class DeleteBlockDialog extends Component {

    _deleteBlock() {
        const payload = {
            userId: this.props.userId ? this.props.userId : -1,
            libraryId: this.props.libraryId,
            blockId: this.props.blockId
        };
        addTenantToPayload(payload, this.props.tenantId, this.props.snapTenantGuid);
        this.props.deleteBlock(payload);
    }

    render() {
        return (
            <div id={"delete-block-dialog-container"}>
                <div id={"delete-block-dialog-wrapper"}>
                    <div className={"delete-block-dialog-header"}>
                        <h4>Confirm Delete Block</h4>
                    </div>
                    <div className={"delete-block-dialog-body"}>
                        <p>
                            Are you sure you want to delete the block &quot;{this.props.blockName}&quot; from
                            the library &quot;{this.props.libraryName}&quot;?
                        </p>
                        <p>
                            This block will be permanently deleted from the library. This action cannot be undone.
                        </p>
                    </div>
                    <div className="delete-block-dialog-footer">
                        <Link to={`/${globalThis.location.search}`}>
                            <button className="btn-continue"
                                    onClick={this._deleteBlock.bind(this)}>CONFIRM DELETE</button>
                        </Link>
                        <Link to={`/${globalThis.location.search}`}>
                            <button className="btn-cancel">CANCEL</button>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

DeleteBlockDialog.propTypes = {
    userId: PropTypes.number,
    libraryId: PropTypes.string.isRequired,
    blockId: PropTypes.string.isRequired,
    blockName: PropTypes.string.isRequired,
    libraryName: PropTypes.string.isRequired,
    tenantId: PropTypes.string,
    snapTenantGuid: PropTypes.string,
    deleteBlock: PropTypes.func.isRequired
};

export default DeleteBlockDialog
